import { database } from '@/firebase';

const {
  getDBTime,
  getCollection,
  updateRecord,
  createRecord,
  deleteRecord,
  addToArray,
} = database;

const fetchPayments = (email) => {
  const payments = { model: 'payments' };
  if (email) {
    payments.where = [{
      prop: 'email',
      comparison: '==',
      value: email,
    }];
  }
  payments.sort = [{
    prop: 'createdAt',
    direction: 'desc',
  }];

  return getCollection(payments);
};

const deletePaymentFromDiscount = ({ discount, payment, season }) => {
  const { payments } = discount;
  const usedDiscount = discountPayment => (
    (discountPayment.email === payment.email) && (discountPayment.season === season.name)
  );
  return payments.filter(discountPayment => !usedDiscount(discountPayment));
};

const updatePaymentFromDiscount = ({
  discount, payment, season, oldPaymentInfo,
}) => {
  const { payments } = discount;
  const editedDiscount = discountPayment => (
    (discountPayment.email === oldPaymentInfo.email) && (discountPayment.season === season.name)
  );

  const editedIndex = payments.findIndex(discountPayment => editedDiscount(discountPayment));
  payments[editedIndex] = {
    email: payment.email,
    season: season.name,
  };

  return payments;
};

export default {
  fetchPayments({ commit }, email) {
    return fetchPayments(email).then((payments) => {
      commit('set', { model: 'payments', value: payments });
      return payments;
    });
  },
  savePayment(state, payload) {
    const { season, discount, ...payment } = payload;
    if (discount) {
      updateRecord({
        model: 'discounts',
        id: discount.id,
        value: {
          payments: addToArray({
            season: season && season.name,
            email: payment.email,
          }),
        },
      });
    }
    return createRecord({
      model: 'payments',
      value: {
        ...payment,
        season: season && season.name,
        discount: discount && discount.code,
        createdAt: getDBTime(),
      },
    });
  },
  updatePayment({ dispatch, getters }, payload) {
    const { season, discount, ...payment } = payload;
    const oldPaymentInfo = getters.getPayment(payment.id);
    const emailMismatch = oldPaymentInfo.email !== payment.email;

    if (discount && emailMismatch) {
      updateRecord({
        model: 'discounts',
        id: discount.id,
        value: {
          payments: updatePaymentFromDiscount({
            payment, season, discount, oldPaymentInfo,
          }),
        },
      });
    }
    updateRecord({
      model: 'payments',
      id: payment.id,
      value: {
        ...payment,
        season: season && season.name,
        discount: discount && discount.code,
      },
    }).then(() => dispatch('fetchPayments'));
  },
  deletePayment({ dispatch }, payload) {
    const { season, discount, ...payment } = payload;
    if (discount) {
      updateRecord({
        model: 'discounts',
        id: discount.id,
        value: {
          payments: deletePaymentFromDiscount({ payment, season, discount }),
        },
      });
    }
    return deleteRecord({
      model: 'payments',
      id: payment.id,
    }).then(() => dispatch('fetchPayments'));
  },
};
